// Sample checklist templates with enhanced categories and features
export const sampleTemplates = {
  comprehensive: {
    id: "comprehensive",
    name: "Comprehensive HACCP Checklist",
    description: "Complete checklist covering all areas including hot/cold holding, cleaning, restaurant and bar checks",
    items: [
      // Hot Holding Items
      {
        id: "hot_chicken",
        type: "temperature",
        label: "Hot Chicken Temperature",
        description: "Check internal temperature of hot chicken dishes",
        required: true,
        min_value: 60,
        unit: "°C",
        category: "hot_holding",
        sauce_options: [
          "Buffalo Sauce",
          "BBQ Sauce",
          "Honey Mustard",
          "Ranch Dressing",
          "Hot Sauce",
          "Garlic Aioli",
          "Teriyaki Sauce"
        ]
      },
      {
        id: "hot_beef",
        type: "temperature", 
        label: "Hot Beef Temperature",
        description: "Check internal temperature of hot beef dishes",
        required: true,
        min_value: 55,
        unit: "°C",
        category: "hot_holding",
        sauce_options: [
          "Au Jus",
          "Horseradish Sauce",
          "Mushroom Gravy",
          "Peppercorn Sauce",
          "Red Wine Reduction",
          "BBQ Sauce"
        ]
      },
      {
        id: "pepper_sauce",
        type: "dropdown",
        label: "Pepper Sauce",
        description: "Select available pepper sauce type",
        required: true,
        category: "hot_holding",
        sauce_options: [
          "Black Pepper Sauce",
          "White Pepper Sauce",
          "Cayenne Pepper Sauce",
          "Hot Pepper Sauce",
          "Mild Pepper Sauce",
          "Green Peppercorn Sauce"
        ]
      },
      
      // Cold Holding Items
      {
        id: "cold_salads",
        type: "temperature",
        label: "Cold Salads Temperature", 
        description: "Check temperature of salad bar items",
        required: true,
        max_value: 5,
        unit: "°C",
        category: "cold_holding",
        sauce_options: [
          "Italian Dressing",
          "Ranch Dressing", 
          "Caesar Dressing",
          "Balsamic Vinaigrette",
          "Thousand Island",
          "Blue Cheese Dressing",
          "Olive Oil & Vinegar"
        ]
      },
      {
        id: "cold_dairy",
        type: "temperature",
        label: "Dairy Products Temperature",
        description: "Check temperature of dairy products (1-4°C / 34-39°F)",
        required: true,
        min_value: 1,
        max_value: 4,
        unit: "°C", 
        category: "cold_holding",
        sauce_options: [
          "Milk (Whole)",
          "Milk (2%)",
          "Heavy Cream",
          "Butter",
          "Cheese (Cheddar)",
          "Cheese (Swiss)",
          "Yogurt"
        ]
      },

      // Refrigeration Items - Fridges
      {
        id: "walk_in_cooler",
        type: "temperature",
        label: "Walk-in Cooler #1",
        description: "Check walk-in cooler temperature (0-4°C / 32-39°F)",
        required: true,
        min_value: 0,
        max_value: 4,
        unit: "°C",
        category: "refrigeration",
        subcategory: "fridges"
      },
      {
        id: "prep_cooler",
        type: "temperature",
        label: "Prep Cooler #1",
        description: "Check prep area cooler temperature (0-4°C / 32-39°F)",
        required: true,
        min_value: 0,
        max_value: 4,
        unit: "°C",
        category: "refrigeration",
        subcategory: "fridges"
      },
      {
        id: "meat_storage",
        type: "temperature",
        label: "Meat Storage Fridge",
        description: "Check meat storage refrigeration (0-4°C / 32-39°F)",
        required: true,
        min_value: 0,
        max_value: 4,
        unit: "°C",
        category: "refrigeration",
        subcategory: "fridges"
      },
      {
        id: "beverage_cooler",
        type: "temperature",
        label: "Beverage Cooler",
        description: "Check beverage refrigeration temperature (0-6°C / 32-43°F)",
        required: true,
        min_value: 0,
        max_value: 6,
        unit: "°C",
        category: "refrigeration",
        subcategory: "fridges"
      },
      {
        id: "dairy_fridge",
        type: "temperature",
        label: "Dairy Refrigerator",
        description: "Check dairy products refrigerator (0-4°C / 32-39°F)",
        required: true,
        min_value: 0,
        max_value: 4,
        unit: "°C",
        category: "refrigeration",
        subcategory: "fridges"
      },

      // Refrigeration Items - Freezers
      {
        id: "main_freezer",
        type: "temperature",
        label: "Main Freezer",
        description: "Check main freezer temperature (-21 to -18°C / -5.8 to -0.4°F)",
        required: true,
        min_value: -21,
        max_value: -18,
        unit: "°C",
        category: "refrigeration",
        subcategory: "freezers"
      },
      {
        id: "walk_in_freezer",
        type: "temperature",
        label: "Walk-in Freezer",
        description: "Check walk-in freezer temperature (-21 to -18°C / -5.8 to -0.4°F)",
        required: true,
        min_value: -21,
        max_value: -18,
        unit: "°C",
        category: "refrigeration",
        subcategory: "freezers"
      },
      {
        id: "ice_cream_freezer",
        type: "temperature",
        label: "Ice Cream Freezer",
        description: "Check ice cream freezer temperature (-23 to -18°C / -9.4 to -0.4°F)",
        required: true,
        min_value: -23,
        max_value: -18,
        unit: "°C",
        category: "refrigeration",
        subcategory: "freezers"
      },
      {
        id: "meat_freezer",
        type: "temperature",
        label: "Meat Freezer",
        description: "Check meat freezer temperature (-21 to -18°C / -5.8 to -0.4°F)",
        required: true,
        min_value: -21,
        max_value: -18,
        unit: "°C",
        category: "refrigeration",
        subcategory: "freezers"
      },

      // Kitchen Cleaning Items
      {
        id: "sanitizer_strength",
        type: "text",
        label: "Sanitizer Solution Strength",
        description: "Check sanitizer concentration using test strips",
        required: true,
        category: "kitchen_cleaning"
      },
      {
        id: "equipment_cleaning",
        type: "cleaning",
        label: "Equipment Deep Clean",
        description: "Verify all equipment has been properly cleaned and sanitized",
        required: true,
        category: "kitchen_cleaning"
      },
      {
        id: "floor_cleaning",
        type: "cleaning", 
        label: "Floor Cleaning & Sanitization",
        description: "Check that floors are clean, dry, and sanitized",
        required: true,
        category: "kitchen_cleaning"
      },
      {
        id: "prep_surfaces",
        type: "cleaning",
        label: "Food Prep Surfaces",
        description: "Clean and sanitize all food preparation surfaces",
        required: true,
        category: "kitchen_cleaning"
      },
      {
        id: "cutting_boards",
        type: "cleaning",
        label: "Cutting Board Sanitization",
        description: "Check that cutting boards are properly cleaned and sanitized",
        required: true,
        category: "kitchen_cleaning"
      },

      // Restaurant Cleaning Items
      {
        id: "dining_tables",
        type: "cleaning",
        label: "Dining Table Cleaning",
        description: "Clean and sanitize all dining tables and chairs",
        required: true,
        category: "restaurant_cleaning"
      },
      {
        id: "condiment_stations",
        type: "restaurant",
        label: "Condiment Station Maintenance",
        description: "Verify condiment stations are clean and well-stocked",
        required: true,
        category: "restaurant_cleaning",
        sauce_options: [
          "Tomato Ketchup",
          "BBQ Sauce", 
          "Mayonnaise",
          "Mustard",
          "Hot Sauce",
          "Ranch Dressing",
          "Honey Mustard",
          "Buffalo Sauce",
          "Garlic Aioli"
        ]
      },
      {
        id: "restroom_cleaning",
        type: "cleaning",
        label: "Restroom Cleaning & Supplies",
        description: "Check that restrooms are clean and properly supplied",
        required: true,
        category: "restaurant_cleaning"
      },
      {
        id: "entrance_cleaning",
        type: "cleaning",
        label: "Entrance & Lobby Areas",
        description: "Clean entrance areas, lobby, and waiting areas",
        required: true,
        category: "restaurant_cleaning"
      },

      // Bar Cleaning Items
      {
        id: "bar_surface_clean",
        type: "cleaning",
        label: "Bar Surface Cleaning",
        description: "Clean and sanitize all bar surfaces and counters",
        required: true,
        category: "bar_cleaning"
      },
      {
        id: "glassware_sanitation",
        type: "cleaning",
        label: "Glassware Sanitization",
        description: "Verify all glassware is properly washed and sanitized",
        required: true,
        category: "bar_cleaning"
      },
      {
        id: "ice_machine_cleaning",
        type: "cleaning",
        label: "Ice Machine Maintenance",
        description: "Clean ice machine and verify ice quality",
        required: true,
        category: "bar_cleaning"
      },
      {
        id: "bar_garnish_station",
        type: "bar",
        label: "Bar Garnish Station",
        description: "Check freshness and organization of bar garnishes",
        required: true,
        category: "bar_cleaning",
        sauce_options: [
          "Lime Wedges",
          "Lemon Wedges",
          "Orange Slices",
          "Maraschino Cherries",
          "Olives",
          "Simple Syrup",
          "Grenadine",
          "Bitters",
          "Tonic Water",
          "Soda Water"
        ]
      }
    ]
  },

  basicCleaning: {
    id: "basic_cleaning",
    name: "Daily Cleaning Checklist",
    description: "Essential daily cleaning and sanitization tasks",
    items: [
      {
        id: "surface_sanitize",
        type: "cleaning",
        label: "Surface Sanitization",
        description: "Sanitize all food preparation surfaces",
        required: true,
        category: "clean_checklist"
      },
      {
        id: "handwash_stations",
        type: "cleaning", 
        label: "Hand Washing Stations",
        description: "Check hand washing stations are stocked and clean",
        required: true,
        category: "clean_checklist"
      },
      {
        id: "waste_disposal",
        type: "cleaning",
        label: "Waste Disposal Area",
        description: "Verify waste is properly disposed and area is clean",
        required: true,
        category: "clean_checklist"
      }
    ]
  }
};